import React, { useMemo } from "react";
import { Box, Typography } from "@mui/material";
import { CardDelivery, CardLogo, GiftCardCard, MerchantName } from "../subComps/getMyGift";

import { DollarTitles } from "../account/components/pieces";
import { formatMoney } from "../../common/utils";
import LoadingSpinner from "../subComps/loadingSpinner";
import type { GetMyGiftOptions, Size } from "../../types";

interface PickYourGiftProps {
    pickCard: (index: number) => void;
    getMyGiftOptions: GetMyGiftOptions | string | undefined;
    size: Size;
}

const PickYourGift = ({ pickCard, getMyGiftOptions, size }: PickYourGiftProps): React.ReactElement => {
    const cards = useMemo(
        () =>
            typeof getMyGiftOptions === `object` &&
            getMyGiftOptions?.rewards &&
            getMyGiftOptions.rewards.map((x, i) => (
                <GiftCardCard key={i} sx={{ cursor: `pointer` }} onClick={() => pickCard(i)}>
                    <Box>
                        <CardLogo src={x.logo} />
                        <MerchantName>{x.brandName}</MerchantName>
                    </Box>
                    <Box>
                        <DollarTitles sx={{ fontSize: 20, margin: `20px 0 5px`, color: `#4a4a4a` }}>
                            {formatMoney((getMyGiftOptions as GetMyGiftOptions).amount)}
                        </DollarTitles>
                        <CardDelivery>{x.delivery === `mail` ? `Physical Delivery` : `Digital Delivery`}</CardDelivery>
                    </Box>
                </GiftCardCard>
            )),
        [getMyGiftOptions]
    );

    return (
        <Box>
            <Typography
                sx={{
                    mt: 2,
                    fontSize: 18,
                    textAlign: `center`,
                    minWidth: `2px`,
                    color: `#4a4a4a`,
                    textWrap: `balance`,
                    fontWeight: 500,
                }}
            >
                {typeof getMyGiftOptions === `object` && getMyGiftOptions?.firstName
                    ? `Hey ${getMyGiftOptions?.firstName},`
                    : ``}
            </Typography>
            <Typography
                component="h1"
                variant="h4"
                sx={{
                    fontFamily: `Plus Jakarta Sans`,
                    width: `100%`,
                    fontSize: size === `small` ? `28px` : `36px`,
                    fontWeight: 800,
                    letterSpacing: `0.01em`,
                    marginBottom: `30px`,
                    textAlign: `center`,
                }}
            >
                You&apos;ve earned it!
                <br />
                Pick your gift.
            </Typography>
            <Box
                sx={{ display: `flex`, justifyContent: `space-around`, alignItems: `space-between`, flexWrap: `wrap` }}
            >
                {cards}
            </Box>
            {getMyGiftOptions === `none` && (
                <Box sx={{ textAlign: `center` }}>Gift info not found. Please access with info provided.</Box>
            )}
            {!cards && !getMyGiftOptions && <LoadingSpinner size={30} />}
        </Box>
    );
};

export default PickYourGift;
